import * as Cesium from 'cesium';
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import { JobStatusEnum } from '../../../Enums';
import StacInterface from "utils/StacInterface";
import exportNotesIcon from "./Icons/export_notes.svg";
import React, { useState, useEffect, useRef } from "react";
import ProgressCloseIcon from 'mdi-react/ProgressCloseIcon';
import ProgressCheckIcon from 'mdi-react/ProgressCheckIcon';
import ProgressClockIcon from 'mdi-react/ProgressClockIcon';
import displayIcon from "./Icons/display_external_input.svg";
import TooltipIconButton from "components/TooltipIconButton";
import ProgressSpannerIcon from 'mdi-react/ProgressSpannerIcon';
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import downloadForOfflineIcon from "./Icons/download_for_offline.svg";
import { Tooltip, Select, MenuItem, IconButton } from "@mui/material";

const Prints = (props) => {
    const [requests, setRequests] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemsStartOffset, setItemsStartOffset] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        StacInterface.instance.getPrintRequests().then(response => {
            setRequests(response.data);
            setTotalItems(response.data.length);
        })

        return (() => {
            if (window.exportsTablePolygon) {
                window.MAIN_CESIUM_VIEWER.entities.remove(window.exportsTablePolygon);
            }
        })
    }, [])

    const viewArea = (req) => {
        if (window.exportsTablePolygon) {
            window.MAIN_CESIUM_VIEWER.entities.remove(window.exportsTablePolygon);
        }
        var boundary = JSON.parse(req.boundary);
        var coords = boundary.coordinates;
        var degArray = []
        var cartoCoords = coords[0].map(c => {
            degArray.push(c[0]);
            degArray.push(c[1]);
            return new Cesium.Cartographic.fromDegrees(c[0], c[1])
        })
        window.exportsTablePolygon = window.MAIN_CESIUM_VIEWER.entities.add({
            rectangle: {
                coordinates: Cesium.Rectangle.fromCartographicArray(cartoCoords),
                material: new Cesium.Color(72 / 255, 123 / 255, 242 / 255, 0.2),
            },
            polyline: {
                positions: Cesium.Cartesian3.fromDegreesArray(degArray),
                width: 1.5,
                material: new Cesium.Color.fromCssColorString('#487BF2'),
                clampToGround: true
            }
        });
        window.MAIN_CESIUM_VIEWER.flyTo(window.exportsTablePolygon);
    }

    const viewMetadata = (req) => {
        dispatch({ type: 'TOGGLE_REQINFO_MODAL', show: true });
        var info = {
            ID: {
                value: req.id
            },
            Collection: {
                value: req.collection_name
            },
            Mission: {
                value: req.mission_name
            },
            Area: {
                value: `${req.area} (km²)`
            },
            'Start Time': {
                value: req.start_datetime ? new Date(`${req.start_datetime}z`).toLocaleString() : null
            },
            'Status Time': {
                value: req.status_datetime ? new Date(`${req.status_datetime}z`).toLocaleString() : null
            },
            'Status': {
                value: req.status === JobStatusEnum.completed ? 'Completed' :
                       req.status === JobStatusEnum.failed ? 'Failed' :
                       req.status === JobStatusEnum.running ? 'Running' :
                       'Not Started',
            },
            'Max Size': {
                value: `${req.max_size} px`
            },
            'Output Format': {
                value: req.output_format
            }
        }
        dispatch({
            type: 'SET_REQINFO_METADATA', reqInfoMetadata: info
        });
    }

    const nextPage = () => {
        if (itemsStartOffset + itemsPerPage < totalItems)
            setItemsStartOffset(itemsStartOffset + itemsPerPage);
    }

    const prevPage = () => {
        if (itemsStartOffset - itemsPerPage >= 0)
            setItemsStartOffset(itemsStartOffset - itemsPerPage);
    }

    const CustomTooltip = (props) => {
        const useStyles = makeStyles((theme) => ({
            tooltip: {
                color: "white",
                fontSize: "12px !important",
                backgroundColor: "#5A5A5A",
                borderRadius: 3,
                fontFamily: 'Roboto',
                padding: '8px 10px'
            }
        }));
        const classes = useStyles();
        return <Tooltip classes={classes} {...props} />;
    }

    return (<>
        <div style={{ fontSize: 21, marginBottom: 15 }}>Print Requests</div>
        <table style={{ width: '100%' }}>
            <tr style={{ fontSize: 11, fontWeight: "bold", borderTop: 'white solid 1px', borderBottom: 'white solid 1px', height: 45 }}>
                <td>DATE</td>
                <td>STATUS</td>
                <td>AREA</td>
                <td>INFO</td>
                <td>DOWNLOAD</td>
            </tr>
            {requests.slice(itemsStartOffset, itemsStartOffset + itemsPerPage).map(r => {
                return (
                    <tr style={{ borderTop: 'white solid 1px', borderBottom: 'white solid 1px', height: 45 }}>
                        <td>{r.start_datetime ? new Date(Date.parse(r.start_datetime)).toLocaleDateString({ year: 'numeric', month: 'numeric', day: 'numeric' }) : null}</td>
                        <td>{r.status === JobStatusEnum.completed ? <CustomTooltip title='Completed' placement='bottom-start'><IconButton><ProgressCheckIcon color='#b8e986' /></IconButton></CustomTooltip> :
                            r.status === JobStatusEnum.failed ? <CustomTooltip title='Failed' placement='bottom-start'><IconButton><ProgressCloseIcon color='#f88e7d' /></IconButton></CustomTooltip> :
                            r.status === JobStatusEnum.running ? <CustomTooltip title='Running' placement='bottom-start'><IconButton><ProgressClockIcon color='#f6da6e' /></IconButton></CustomTooltip> :
                            <CustomTooltip title='Not Started' placement='bottom-start'><IconButton><ProgressSpannerIcon color='#ddd' /></IconButton></CustomTooltip>}</td>
                        <td><CustomTooltip title="View Area" placement="bottom-start"><IconButton onClick={() => viewArea(r)}><img src={displayIcon} style={{height:'24px'}}/></IconButton></CustomTooltip></td>
                        <td><CustomTooltip title="View Metadata" placement="bottom-start"><IconButton onClick={() => viewMetadata(r)}><img src={exportNotesIcon} style={{height:'24px'}}/></IconButton></CustomTooltip></td>
                        <td><CustomTooltip title="Download File" placement="bottom-start">{
                            r.status === JobStatusEnum.completed ? 
                            <IconButton><a href={r.output_address} target="_blank" ><img src={downloadForOfflineIcon} style={{height:'24px'}}/></a></IconButton> :
                            <IconButton disabled><img src={downloadForOfflineIcon} style={{height:'24px'}}/></IconButton>
                            }</CustomTooltip>
                        </td>
                    </tr>
                )
            })}
        </table>
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between', 
            marginTop: 15, 
            marginBottom: 5, 
            flexWrap: 'wrap'
        }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ fontSize: "1.1rem", color: "#fff" }}>Rows per page:</span>
                <Select
                    value={itemsPerPage}
                    variant="outlined"
                    size="small"
                    style={{ 
                        marginLeft: 12, 
                        marginRight: 8, 
                        color: "#fff", 
                        background: "#323232",
                        borderRadius: 4,
                        minWidth: 60
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                background: "#232323",
                                color: "#fff"
                            }
                        }
                    }}
                    onChange={(evt) => setItemsPerPage(evt.target.value)}>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                </Select>
                {totalItems === 0 ? null : (
                    <span style={{ fontSize: "1.1rem", marginLeft: 18, color: "#bbb" }}>
                        {itemsStartOffset + 1} - {itemsStartOffset + itemsPerPage <= totalItems ? itemsStartOffset + itemsPerPage : totalItems} of {totalItems}
                    </span>
                )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <TooltipIconButton title="Previous" ariaLabel="Previous" size={35} onClick={prevPage}>
                    <ChevronLeft />
                </TooltipIconButton>
                <TooltipIconButton title="Next" ariaLabel="Next" size={35} onClick={nextPage}>
                    <ChevronRight />
                </TooltipIconButton>
            </div>
        </div>
    </>)
}

export default Prints;